import { type SystemRole, useCurrentUser } from '@state/user.ts'

function useHasSystemRole(role: SystemRole) {
  const { role: currentUserRole } = useCurrentUser()
  return currentUserRole === role
}

export default useHasSystemRole